export const tr = {
    Mancala: "Köçürme",
    Leave: "Oyundan Ayrıl",
    NewGame: "Yeni Oyun",
    YourTurn: "Sıra Sende",
    OpponentTurn: "Sıra Rakipte",
    GameEnded: "Oyun Bitti",
    InternalErrorOccurred: "Dahili bir hata oluştu",
    YouWon: "Kazandın",
    Won: "Kazandı",
    YouLost: "Kaybettin",
    Connecting: "Bağlanılıyor",
    Connected: "Bağlandı",
    CannotConnect: "Bağlanılamadı",
    ConnectionLost: "Ağ Bağlantısı Koptu",
    ConnectingAgain: "Tekrar Bağlanılıyor",
    ServerError: "Sunucu Hatası",
    SearchingOpponet: "Rakip Aranıyor",
    OpponentLeftTheGame: "Rakip Oyundan Ayrıldı",
    YouLeftTheGame: "Sen Oyundan Ayrıldın",
    UserLeftTheGame: "Oyundan Ayrıldı",
    SearchingOpponent: "Rakip Aranıyor",
    PleaseWait: "Lütfen Bekleyin",
    GameDraw: "Berabere",
    Anonymous: "Anonim",
    GameNotFound: "Oyun Bulunamadı",
    Loading: "Yükleniyor",
    Playing: "Oynuyor",
    Error: "Hata",
    ErrorWhenRetrievingInformation: "Bilgiler toplanırken bir hata oluştu!",
    UCanOnlyPlayYourOwnPits: "Sadece sana ait olan kuyular ile oynayabilirsin",
    UMustWaitUntilCurrentMoveComplete: "Devam eden haraketin bitmesini beklemelisin",
    UCanNotPlayEmptyPit: "Boş kuyu ile oynayamazsın",
    AreYouSureToLeaveGame: "Oyundan ayrılmak istediğine emin misin?",
    Yes: "Evet",
    Cancel: "İptal",
    Help: "Yardım",
    WebApp: "Web Uygulamasına Git",
    Privacy: "Gizlilik Politikasını Göster",
    Home: "Ana Sayfa",
    RejoinGame: "Oyuna Geri Dön",
    Guest: "Misafir",
    LogIn: "Giriş Yap",
    SignUp: "Kayıt Ol",
    LogOut: "Çıkış Yap",
    LiveGames: "Canlı Oyunlar",
    PopularGames: "Popüler Oyunlar",
    MyRecentGames: "Son Oyunlarım",
    NoGamesYet: "Henüz oyun yok",
    Watching: "{{count}} izliyor",
    GameInProgress: "Devam eden bir oyunun var",
    Continue: "Devam Et",
    Versus: "-",
    Draw: "Berabere",
    OpponentLeft: "Rakip ayrıldı",
    YouLeft: "Sen ayrıldın",
    OpponentTimedOut: "Rakibin süresi doldu",
    YouTimedOut: "Süren doldu",
    Abandoned: "Yarıda kaldı",
    PlayerWon: "{{name}} kazandı",
    Moves: "Hamleler",
    PitNumber: "{{pit}}. kuyu",
    ExtraTurn: "Ekstra tur",
    Capture: "Taş aldı",
    StoreGain: "Hazineye +{{count}}",
    GameOver: "Oyun bitti",
    ViewingMove: "{{number}}. hamleye bakıyorsun",
    MoveOf: "Hamle {{number}} / {{total}}",
    MoveNumber: "{{number}}. hamle",
    Start: "Başlangıç",
    BackToLive: "Canlıya dön",
    WatchFromStart: "Baştan izle",
    Speed: "Hız",
    Duration: "Süre",
    You: "Sen",
    Opponent: "Rakip",
    StoreCount: "Hazine {{count}}",
    Online: "Çevrimiçi",
    Offline: "Çevrimdışı",
    ChooseTheme: "Tema seç",
    ThemeWalnut: "Ceviz tema",
    ThemeNight: "Gece tema",
    ThemeJade: "Yeşim tema",
    Account: "Hesap",
    NewestFirst: "en yeni üstte",
    BeingPlayedNow: "Şu an oynanıyor",
    MostWatched: "En çok izlenenler",
    YourGames: "Senin maçların",
    GameWithOpponent: "{{name}} ile oyunun sürüyor",
    StoreScores: "Hazinen {{mine}}, rakibin {{theirs}}",
    Live: "Canlı",
    Close: "Kapat",
    Play: "Oynat",
    Pause: "Duraklat",
    FirstMove: "Başa dön",
    PreviousMove: "Önceki hamle",
    NextMove: "Sonraki hamle",
    LastMove: "Sona git",
    MovePosition: "Hamle konumu",
    PlaybackControls: "Oynatma kontrolleri",
    PlaybackSpeed: "Oynatma hızı",
    GameSummary: "Oyun özeti",
    StartPosition: "Her kuyuda 4 taş",
    MoveCount: "{{count}} hamle",
    PitLabel: "{{name}}, {{pit}}. kuyu, {{count}} taş",
    StoreLabel: "{{name}} hazinesi, {{count}} taş",
    OpenGame: "Oyunu aç",
    Score: "Skor",
    PlayWithBot: "Bota karşı oyna",
    NoOpponentYet: "Henüz rakip bulunamadı. Bota karşı oynamak ister misin?",
    ChooseBotLevel: "Botun ne kadar güçlü olacağını seç",
    Bot: "Bot",
    BotLevelEasy: "Kolay",
    BotLevelMedium: "Orta",
    BotLevelHard: "Zor",
    BotLevelMaster: "Usta",
    PlayAgain: "Tekrar oyna",
    RuleBoardTitle: "Tahta ve amaç",
    RuleBoardText1: "Her oyuncunun tahtada kendi tarafında 6 kuyusu ve sırasının sonunda büyük bir hazinesi vardır. Her kuyuda başta 4 taş bulunur.",
    RuleBoardText2: "Hazinene giren taşlar senindir. Sıran geldiğinde kendi kuyularından birini oynarsın, sonra sıra rakibe geçer.",
    RuleBoardText3: "Oyun bittiğinde hazinesinde daha çok taş olan kazanır. Toplam 48 taş var, yani 25 taş her zaman kazandırır.",
    RuleSowingTitle: "Taşları dağıtmak",
    RuleSowingText1: "Kuyularından birindeki bütün taşları al. İlkini aynı kuyuya geri bırak, kalanları hazinene doğru sıradaki kuyulara birer birer bırak.",
    RuleSowingText2: "Kuyuda tek taş varsa o taş bir sonraki kuyuya geçer.",
    RuleSowingText3: "Hazinenin üzerinden geçerken ona da bir taş bırakırsın; rakibin hazinesi atlanır.",
    RuleExtraTurnTitle: "Bir hamle daha",
    RuleExtraTurnText1: "Son taşın hazinene düşerse bir kez daha oynarsın.",
    RuleExtraTurnText2: "Taşları say: taşları tam hazinende biten kuyu sana bir hamle daha kazandırır.",
    RuleEvenCaptureTitle: "Çift yapıp almak",
    RuleEvenCaptureText1: "Son taşın rakibin bir kuyusuna düşer ve oradaki taş sayısını çift yaparsa, o kuyudaki bütün taşları hazinene alırsın.",
    RuleEvenCaptureText2: "Sayı tek olursa bir şey alınmaz, sıra rakibe geçer.",
    RuleEmptyPitCaptureTitle: "Boş kuyudan almak",
    RuleEmptyPitCaptureText1: "Son taşın kendi tarafındaki boş bir kuyuya düşer ve rakibin karşıdaki kuyusunda taş varsa, o taşı ve karşıdaki bütün taşları hazinene alırsın.",
    RuleEmptyPitCaptureText2: "Karşıdaki kuyu boşsa bir şey alınmaz.",
    RuleEndOfGameTitle: "Oyunun sonu",
    RuleEndOfGameText1: "Bir taraftaki bütün kuyular boşaldığı anda oyun biter.",
    RuleEndOfGameText2: "Tarafı boşalan oyuncu, karşı tarafta kalan bütün taşları alır.",
    RuleEndOfGameText3: "Sonra hazineler sayılır: çok taşı olan kazanır, eşitse oyun berabere biter.",
    RuleClockTitle: "Süre",
    RuleClockText1: "Her oyuncunun bütün oyun için 5 dakikası vardır. Yalnızca sırası gelen oyuncunun süresi işler.",
    RuleClockText2: "Süresi biten oyuncu kaybeder.",
    LessonTaskAnyMove: "Alt sıradaki kuyularından birini oyna ve taşları izle.",
    LessonTaskSowing: "Herhangi bir kuyuyu oyna. Tek taşlı kuyuyu da dene.",
    LessonTaskExtraTurn: "Son taşı hazinene düşen kuyuyu bul.",
    LessonTaskEvenCapture: "Son taşınla rakibin bir kuyusunu çift yap.",
    LessonTaskEmptyPitCapture: "Hamleni boş kuyunda bitir ve karşıdaki taşları al.",
    LessonTaskEndGame: "Son taşını oyna ve kalan taşların kime gittiğini gör.",
    MoveExplainExtraTurnYou: "Son taşın hazinene düştü: bir kez daha oynuyorsun.",
    MoveExplainExtraTurnBot: "Botun son taşı kendi hazinesine düştü: bir kez daha oynuyor.",
    MoveExplainEvenYou: "Son taşın rakibin kuyusunu çift yaptı: {{count}} taş aldın.",
    MoveExplainEvenBot: "Botun son taşı senin bir kuyunu çift yaptı: {{count}} taş aldı.",
    MoveExplainEmptyPitYou: "Son taşın kendi boş kuyuna düştü: onu ve karşıdaki {{count}} taşı aldın.",
    MoveExplainEmptyPitBot: "Botun son taşı kendi boş kuyusuna düştü: onu ve karşısındaki {{count}} taşını aldı.",
    MoveExplainOddYou: "Son taşın rakibin kuyusunda {{count}} taş bıraktı, bu tek sayı: bir şey alınmadı, sıra rakibe geçti.",
    MoveExplainOddBot: "Botun son taşı senin kuyunda {{count}} taş bıraktı, bu tek sayı: bir şey almadı.",
    MoveExplainOwnPitYou: "Son taşın kendi dolu kuyuna düştü: sıra rakibe geçti.",
    MoveExplainOwnPitBot: "Botun son taşı kendi kuyusuna düştü: sıra sende.",
    MoveExplainEmptyOppositeYou: "Son taşın boş kuyuna düştü ama karşıdaki kuyu da boştu: alınacak taş yok.",
    MoveExplainEmptyOppositeBot: "Botun son taşı boş kuyusuna düştü ama karşısındaki kuyun boştu: bir şey almadı.",
    MoveExplainGameOver: "Bir taraf boşaldı, oyun bitti.",
    HowToPlay: "Nasıl oynanır",
    LearnMangala: "Mangala öğren",
    Lessons: "Dersler",
    TryIt: "Dene",
    Hints: "İpuçları",
    HintExtraTurn: "Bir hamle daha",
    HintCaptures: "{{count}} taş alır",
    NewToMangala: "Mangala'da yeni misin? 3 dakikada öğren.",
    StartTutorial: "Başla",
    NotNow: "Şimdi değil",
    PracticeGame: "Alıştırma oyunu",
    PracticeGameText: "İpuçları açıkken Kolay bota karşı oyna.",
    WellDone: "Harika!",
    NextLesson: "Sonraki ders",
    TryAgain: "Tekrar dene",
    LessonDone: "Tamamlandı",
    AllLessons: "Tüm dersler",
    LessonNumber: "Ders {{number}} / {{count}}",
    Rematch: "Rövanş",
    No: "Hayır",
    RematchWaiting: "{{name}} bekleniyor…",
    RematchRequested: "{{name}} rövanş istiyor",
    RematchDeclined: "{{name}} rövanşı kabul etmedi",
    RematchWithdrawn: "{{name}} rövanştan vazgeçti",
    RematchNoAnswer: "{{name}} cevap vermedi",
    RematchRequestExpired: "Rövanş isteğinin süresi doldu",
    RematchOpponentGone: "{{name}} artık burada değil",
    RematchClosed: "Rövanş artık mümkün değil",
    Series: "Seri",
    SeriesScoreText: "Seri: {{first}} {{firstWins}} – {{secondWins}} {{second}}",
    SeriesGameNumber: "{{number}}. oyun",
    SeriesCurrentGame: "Şimdi",
    SeriesEarlierGames: "{{count}} önceki oyun",
    MovedFirst: "İlk hamle",
    EndedOnTime: "süre",
    EndedByLeaving: "ayrıldı",
    Settings: "Ayarlar",
    Theme: "Tema",
    ThemeWalnutName: "Ceviz",
    ThemeNightName: "Gece",
    ThemeJadeName: "Yeşim",
    PlayBot: "Bota karşı",
};